import React, { Suspense, useEffect, useState } from "react";
import {
  Layout,
  Typography,
  Flex,
  Menu,
  MenuProps,
  Breadcrumb,
  Popconfirm,
} from "antd";
import { LogoutOutlined } from "@ant-design/icons";

import {
  UserAddOutlined,
  GroupOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import FlatButton from "@/components/button/button";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const { Text } = Typography;
const { Content, Header, Sider } = Layout;

type MenuItem = Required<MenuProps>["items"][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

const items: MenuItem[] = [
  getItem("ユーザー管理", "/admin/user-management", <GroupOutlined />),
  getItem("ユーザー作成", "/admin/create-user", <UserAddOutlined />),
];

const rootSubmenuKeys = ["/admin/user-management", "/admin/create-user"];

const Home: React.FC = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const email = localStorage.getItem("email");

  const [openKeys, setOpenKeys] = useState(["/admin/user-management"]);
  const [selectedKey, setSelectedKey] = useState<string>(location.pathname);

  useEffect(() => {
    setSelectedKey(location.pathname);
  }, [location.pathname]);

  const onOpenChange: MenuProps["onOpenChange"] = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const onMenuClick = (path: string) => {
    setSelectedKey(path);
    navigate(path);
  };

  const onLogout = () => {
    localStorage.removeItem("access_token");
    navigate("/admin/login", { replace: true });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={false}
        className="layout-page-sider"
        trigger={null}
        style={{ backgroundColor: "white" }}
        collapsedWidth={80}
        breakpoint="md"
      >
        <Menu
          selectedKeys={[selectedKey]}
          openKeys={openKeys ? openKeys : []}
          defaultSelectedKeys={["user-management"]}
          onSelect={(k) => onMenuClick(k.keyPath[0])}
          mode="inline"
          items={items}
          onOpenChange={onOpenChange}
        />
      </Sider>

      <Layout style={{ padding: 0 }}>
        <Header style={{ backgroundColor: "white", fontWeight: "bold", padding: "24px 36px" }}>
          <Flex justify={"space-between"} align={"flex-start"}>
            <Breadcrumb>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item>
                {location.pathname.replace("/", "")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <Flex justify={"flex-end"}>
              <Typography.Text style={{ fontSize: 16, color: "#40C1A2", padding: "0 12px" }}>
                {email}
              </Typography.Text>
              <Popconfirm
                title="ログアウト"
                description="ログアウトしてもよろしいですか?"
                onConfirm={onLogout}
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              >
                <FlatButton
                  icon={<LogoutOutlined />}
                  type="primary"
                  size="large"
                  danger
                >
                  ログアウト
                </FlatButton>
              </Popconfirm>
            </Flex>
          </Flex>
        </Header>

        <Content
          className="layout-page-content"
          style={{
            padding: 16,
          }}
        >
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Home;
